import 'vite/modulepreload-polyfill'
import '@styles'
import jQuery from 'jquery'
// assign jQuery to global scope
window.$ = window.jQuery = jQuery
import classie from 'classie'
import 'jquery-menu-aim'
import routes from '@utils/routes'
import Hammer from 'hammerjs'
import productViewer from './components/productViewer'
import {
  debounce,
  checkMq,
  getAncestor,
  getSiblings,
  elementIndex,
  getTranslateXValue,
  setTransformValue,
} from '@helpers'
import { getMapStyle, getMapMarker } from '@mapHelpers'
import { loadDealers, setDealerInfo, getDealerId } from './util/dealers'

/*
  Handle dynamic imports
*/

routes()

/*
  Main navigation
*/

const mainHeader = document.getElementsByClassName('main-header')[0]
const mobileNavActions = mainHeader.querySelector('.mobile-actions')
const modelNavigation = mainHeader.querySelector('.models-navigation')
const rightNavigation = mainHeader.querySelector('.right-navigation')
const bgLayer = document.getElementsByClassName('bg-layer')[0]

function closeModelsNavigation() {
  const modelDropdownOpen = modelNavigation.querySelector('.subnav-visible')
  if (modelDropdownOpen) {
    classie.remove(modelDropdownOpen, 'subnav-visible')
    classie.remove(modelDropdownOpen, 'only-subnav-visible')
  }
}

function closeRightNavigation() {
  classie.remove(rightNavigation, 'open')
  const menuDropdownOpen = mobileNavActions.querySelector('.nav-trigger.sub-nav-open')
  if (menuDropdownOpen) {
    classie.remove(menuDropdownOpen, 'sub-nav-open')
    classie.remove(menuDropdownOpen, 'only-subnav-visible')
  }
}

function checkBgLayer() {
  const modelDropdownOpen = modelNavigation.querySelector('.subnav-visible')
  if (!modelDropdownOpen && !classie.has(rightNavigation, 'open')) classie.remove(bgLayer, 'visible')
}

//open navigation on mobile - on desktop open dropdown navigation(right nav)
mobileNavActions.addEventListener('click', function (event) {
  event.preventDefault()
  let anchorTarget
  if (classie.has(event.target.parentElement, 'nav-trigger') || classie.has(event.target, 'nav-trigger')) {
    anchorTarget = classie.has(event.target, 'nav-trigger') ? event.target : event.target.parentElement
    //check if the dark bg needs to be added/removed
    if (classie.has(rightNavigation, 'open')) {
      classie.remove(bgLayer, 'visible')
    } else {
      classie.add(bgLayer, 'visible')
    }
    classie.toggle(anchorTarget, 'sub-nav-open')
    classie.toggle(rightNavigation, 'open')
  } else if (classie.has(event.target.parentElement, 'models-trigger') || classie.has(event.target, 'models-trigger')) {
    anchorTarget = classie.has(event.target, 'models-trigger') ? event.target : event.target.parentElement
    classie.toggle(anchorTarget, 'sub-nav-open')
    classie.toggle(modelNavigation, 'open')
  }
})

//on mobile switch from a product tab to another; on desktop toggle product megamenu
modelNavigation.addEventListener('click', function (event) {
  let siblings
  if (event.target.tagName.toLowerCase() == 'a' && classie.has(event.target, 'subcat-label')) {
    event.preventDefault()
    const visibleDropdown = modelNavigation.getElementsByClassName('subnav-visible')
    classie.add(event.target.parentElement, 'selected') //this is used on mobile only (no toggle)
    siblings = getSiblings(event.target.parentElement)

    //open/close and check if another dropdown is already open
    if (classie.has(event.target.parentElement, 'subnav-visible')) {
      classie.remove(event.target.parentElement, 'subnav-visible') //this is used for the desktop version
      classie.remove(event.target.parentElement, 'only-subnav-visible')
      classie.remove(bgLayer, 'visible')
    } else {
      if (!visibleDropdown[0]) classie.add(event.target.parentElement, 'only-subnav-visible')
      classie.add(event.target.parentElement, 'subnav-visible')
      classie.add(bgLayer, 'visible')
    }

    for (let i = 0; i < siblings.length; i++) {
      classie.remove(siblings[i], 'selected')
      classie.remove(siblings[i], 'subnav-visible')
      classie.remove(siblings[i], 'only-subnav-visible')
    }
    closeRightNavigation()
  } else if (classie.has(event.target, 'subcat-material') && !classie.has(event.target.parentElement, 'hover')) {
    //desktop - select a different product category in the left navigation (steel, aluminum ...)
    event.preventDefault()
    classie.add(event.target.parentElement, 'hover')
    siblings = getSiblings(event.target.parentElement)
    for (let i = 0; i < siblings.length; i++) classie.remove(siblings[i], 'hover')
  }
})

//configurations - change image on hover
const configurationsWrapper = modelNavigation.querySelectorAll('.js-configurations')
const imageConfigurationsWrapper = modelNavigation.querySelectorAll('.main-img-subcat')
for (let i = 0; i < configurationsWrapper.length; i++) {
  ;(function (i) {
    const configurations = configurationsWrapper[i].querySelectorAll('li')
    const imageConfigurations = imageConfigurationsWrapper[i].querySelectorAll('li')
    for (let j = 0; j < configurations.length; j++) {
      ;(function (j) {
        configurations[j].addEventListener('mouseenter', function () {
          for (let n = 0; n < configurations.length; n++) {
            classie.remove(imageConfigurations[n], 'config-selected')
            classie.remove(configurations[n], 'config-selected')
          }
          classie.add(imageConfigurations[j], 'config-selected')
          classie.add(configurations[j], 'config-selected')
        })
      })(j)
    }
  })(i)
}

//close subnavigation cliking outside it the page
document.addEventListener('click', function (event) {
  // if(  ( !getSiblings(event.target)[0] || !classie.has(getSiblings(event.target)[0], 'product-sub-categories') ) && !classie.has(event.target, 'product-sub-categories') && !getAncestor(event.target, 'product-sub-categories') && modelNavigation.querySelector('li.subnav-visible')) classie.remove(modelNavigation.querySelector('li.subnav-visible'), 'subnav-visible');
  if (
    (!getSiblings(event.target)[0] || !classie.has(getSiblings(event.target)[0], 'product-sub-categories')) &&
    !classie.has(event.target, 'product-sub-categories') &&
    !getAncestor(event.target, 'product-sub-categories') &&
    modelNavigation.querySelector('li.subnav-visible')
  ) {
    closeModelsNavigation()
    checkBgLayer()
  }
  if (
    !classie.has(event.target, 'nav-trigger') &&
    !classie.has(event.target.parentElement, 'nav-trigger') &&
    !classie.has(event.target, 'company') &&
    !getAncestor(event.target, 'company')
  ) {
    closeRightNavigation()
    checkBgLayer()
  }
  if (
    document.getElementsByClassName('interest-points')[0] &&
    !classie.has(event.target, 'close-point-info') &&
    !getAncestor(event.target, 'single-point')
  ) {
    const openInterestPoint = document.getElementsByClassName('interest-points')[0].querySelector('.is-open')
    if (openInterestPoint) {
      classie.remove(openInterestPoint, 'is-open')
      classie.add(openInterestPoint, 'visited')
    }
  }
})

//desktop -  hover effect
const $subCategories = $(modelNavigation).find('.product-sub-categories')
const $listWrapper = $subCategories.children('ul')

$listWrapper.each(function () {
  $(this).menuAim({
    activate: function (row) {
      $(row).addClass('hover')
    },
    deactivate: function (row) {
      $(row).removeClass('hover')
    },
    rowSelector: '> li.sub-cat-item',
    tolerance: 1200,
  })
})

//close navigation on esc click
document.addEventListener('keyup', function (event) {
  if (event.keyCode == 27) {
    closeModelsNavigation()
    closeRightNavigation()
    classie.remove(bgLayer, 'visible')
  }
})

/*
    Secondary navigation
  */

const secondaryNav = document.querySelector('.js-secondary-nav')
const productSidebar = document.querySelector('.spec-sidebar')
const selectedModel = document.querySelector('.chosen-model')
const belowSecondaryNav = document.querySelector('.below-secondary-nav')
let secondaryScroll = false
let secondaryNavTop
const productSidebarParent = productSidebar?.parentElement
const productSidebarLinks = productSidebar?.getElementsByTagName('a')
let previousTop = 0
let currentTop = 0

if (productSidebar) {
  $('html').css('scroll-behavior', 'smooth')
  if (secondaryNav) {
    secondaryNavTop = belowSecondaryNav.offsetTop - secondaryNav.offsetHeight + 10
  } else {
    secondaryNavTop = belowSecondaryNav.offsetTop
  }
}
if (secondaryNav) {
  secondaryNavTop = belowSecondaryNav.offsetTop - secondaryNav.offsetHeight

  window.addEventListener('scroll', function () {
    secondaryScroll = debounce(!secondaryScroll, secondaryScroll, function () {
      checkSecondaryNav(secondaryNavTop, mainHeader.offsetHeight)
    })
  })

  window.addEventListener('resize', function () {
    secondaryNavTop = belowSecondaryNav.offsetTop - secondaryNav.offsetHeight
    // if(checkMq() != 'desktop')
    mainHeader.removeAttribute('style')
  })
} else if (productSidebar) {
  window.addEventListener('scroll', function () {
    secondaryScroll = debounce(!secondaryScroll, secondaryScroll, checkProductSidebar)
  })
}

function checkSecondaryNav(secondaryNavTop, headerHeight) {
  currentTop = $(window).scrollTop()
  if (previousTop > currentTop && classie.has(secondaryNav, 'fixed')) {
    //if scrolling up...
    if (currentTop > secondaryNavTop - headerHeight) {
      classie.add(secondaryNav, 'slide-down')
      classie.remove(secondaryNav, 'slide-up')
      classie.remove(mainHeader, 'slide-up')
    } else {
      classie.remove(secondaryNav, 'slide-down')
      classie.remove(secondaryNav, 'fixed')
      classie.remove(belowSecondaryNav, 'secondary-nav-fixed')
    }
  } else if (previousTop < currentTop) {
    //if scrolling down...
    classie.remove(secondaryNav, 'slide-down')

    if (currentTop >= secondaryNavTop - headerHeight + 200) {
      classie.add(mainHeader, 'slide-up')
      classie.add(secondaryNav, 'fixed')
      classie.add(secondaryNav, 'slide-up')
      classie.add(belowSecondaryNav, 'secondary-nav-fixed')
    } else if (currentTop >= secondaryNavTop - headerHeight) {
      classie.add(secondaryNav, 'fixed')
      classie.remove(secondaryNav, 'slide-up')
      classie.remove(mainHeader, 'slide-up')
      classie.add(belowSecondaryNav, 'secondary-nav-fixed')
    } else {
      classie.remove(secondaryNav, 'fixed')
      classie.remove(secondaryNav, 'slide-up')
      classie.remove(mainHeader, 'slide-up')
      classie.remove(belowSecondaryNav, 'secondary-nav-fixed')
    }
  }

  previousTop = currentTop

  //include also a check for product specifications sidebar - to be fixed on scrolling
  productSidebar ? checkProductSidebar() : (secondaryScroll = false)
}

function checkProductSidebar() {
  let navOffset = secondaryNav ? mainHeader.offsetHeight - 20 : -mainHeader.offsetHeight - 20
  if (classie.has(productSidebar, 'specialized')) navOffset = -secondaryNav.offsetHeight - 20
  if (
    $(window).scrollTop() >
    productSidebarParent.offsetTop + navOffset + productSidebarParent.offsetHeight - productSidebar.offsetHeight
  ) {
    classie.remove(productSidebar, 'fixed')
    productSidebar.setAttribute('style', `top: ${productSidebarParent.offsetHeight - productSidebar.offsetHeight}px;`)
    if (selectedModel) classie.remove(selectedModel, 'slide-in')
  } else if ($(window).scrollTop() > productSidebarParent.offsetTop + navOffset) {
    classie.add(productSidebar, 'fixed')
    productSidebar.removeAttribute('style')
    if (selectedModel) classie.add(selectedModel, 'slide-in')
  } else {
    classie.remove(productSidebar, 'fixed')
    productSidebar.removeAttribute('style')
    if (selectedModel) classie.remove(selectedModel, 'slide-in')
  }

  updateVisibleSection()
}

function updateVisibleSection() {
  let navOffset = secondaryNav ? 0 : mainHeader.offsetHeight + 20
  if (classie.has(productSidebar, 'specialized')) navOffset = secondaryNav.offsetHeight + 20
  for (let i = 0; i < productSidebarLinks.length; i++) {
    const section = document.getElementById(productSidebarLinks[i].hash.replace('#', ''))
    if (productSidebarParent.offsetTop + section.offsetTop - navOffset <= $(window).scrollTop()) {
      classie.add(productSidebarLinks[i].parentElement, 'selected')
      if (i > 0) classie.remove(productSidebarLinks[i - 1].parentElement, 'selected')
    } else {
      classie.remove(productSidebarLinks[i].parentElement, 'selected')
    }
  }
  secondaryScroll = false
}

/*
    HERO SLIDER - gallery slider
  */
function heroSlider(element) {
  this.element = element
  this.slidesWrapper = this.element.querySelector('.slider-list')
  this.slides = this.slidesWrapper.getElementsByTagName('li')
  this.slidesNumber = this.slides.length
  if (this.element.querySelector('.slider-navigation')) {
    this.controls = this.element.querySelector('.slider-navigation')
    this.controlsBtn = this.controls.getElementsByTagName('a')
  } else {
    this.controls = null
    this.controlsBtn = null
  }
  if (this.element.querySelector('.slider-arrow-navigation')) {
    this.arrowControls = this.element.querySelector('.slider-arrow-navigation')
  } else {
    this.arrowControls = null
  }
  if (this.element.querySelector('.js-download-btn')) {
    this.downloadBtn = this.element.querySelector('.js-download-btn')
  } else {
    this.downloadBtn = null
  }
  this.visibleSlide = 0
  this.oldVisibleSlide = 0
  this.intervalID
  this.heroBindEvents()
  this.initAutoplay()
  this.initSlider() // this is for gallery only
}

heroSlider.prototype.heroBindEvents = function () {
  const self = this

  if (this.slides[this.visibleSlide] && this.slides[this.visibleSlide].getAttribute('data-type') == 'video')
    this.loadBgVideo()

  if (this.controls) {
    this.controls.addEventListener('click', function (event) {
      if (event.target.tagName.toLowerCase() === 'a' && !classie.has(event.target, 'selected')) {
        event.preventDefault()
        self.oldVisibleSlide = self.visibleSlide
        self.visibleSlide = elementIndex(event.target.parentElement)
        self.showNewSlide()
      } else if (event.target.tagName.toLowerCase() === 'img' && !classie.has(event.target.parentElement, 'selected')) {
        event.preventDefault()
        self.oldVisibleSlide = self.visibleSlide
        self.visibleSlide = elementIndex(event.target.parentElement.parentElement)
        self.showNewSlide()
      }
    })
  }

  if (this.arrowControls) {
    this.arrowControls.addEventListener('click', function (event) {
      if (event.target.tagName.toLowerCase() === 'a') {
        event.preventDefault()
        self.prevNextSlide(classie.has(event.target, 'prev'))
      }
    })
  }

  //swipe effect using jQuery mobile

  if (!this.disableSwipe) {
    $(this.element).each(function () {
      const h = new Hammer(this)
      h.on('swipeleft', function () {
        self.prevNextSlide(false)
      })
      h.on('swiperight', function () {
        self.prevNextSlide(true)
      })
    })
  }

  if (classie.has(this.element, 'js-gallery-popup')) {
    document.addEventListener('keyup', function (event) {
      if (event.keyCode == 39) {
        self.prevNextSlide(false)
      } else if (event.keyCode == 37) {
        self.prevNextSlide(true)
      }
    })
  }

  $(this.element).on('openGallery', function (event, itemNumber) {
    //!!! Make sure itemNumber is a number
    self.slides = self.slidesWrapper.getElementsByTagName('li')
    self.slidesNumber = self.slides.length
    self.showInitialSlide(itemNumber, 'open')
  })
}

heroSlider.prototype.prevNextSlide = function (bool) {
  this.oldVisibleSlide = this.visibleSlide
  this.updateVisibleSlide(bool)
  this.showNewSlide()
}

heroSlider.prototype.updateVisibleSlide = function (targetIsPrev) {
  this.visibleSlide = targetIsPrev ? this.oldVisibleSlide - 1 : this.oldVisibleSlide + 1

  if (this.visibleSlide < 0) this.visibleSlide = this.slidesNumber - 1
  if (this.visibleSlide >= this.slidesNumber) this.visibleSlide = 0

  if (
    (classie.has(this.element, 'filter-gallery-popup') ||
      classie.has(this.element, 'js-filter-visible-gallery-popup')) &&
    !$(this.slides[this.visibleSlide]).is(':visible')
  ) {
    //you need to check if the new slide is visible or not
    this.filterVisibleSlides(targetIsPrev)
  }
}

heroSlider.prototype.filterVisibleSlides = function (targetIsPrev) {
  this.visibleSlide = targetIsPrev ? this.visibleSlide - 1 : this.visibleSlide + 1
  if (this.visibleSlide < 0) this.visibleSlide = this.slidesNumber - 1
  if (this.visibleSlide >= this.slidesNumber) this.visibleSlide = 0

  if (!$(this.slides[this.visibleSlide]).is(':visible')) {
    this.filterVisibleSlides(targetIsPrev)
  }
}

heroSlider.prototype.initAutoplay = function () {
  if ((this.controls && !classie.has(this.controls, 'js-no-autoplay')) || classie.has(this.element, 'js-autoplay')) {
    const self = this
    if ($(this.element).attr('data-delay')) {
      setTimeout(function () {
        self.intervalID = setInterval(function () {
          self.oldVisibleSlide = self.visibleSlide
          self.visibleSlide = self.visibleSlide + 1 == self.slidesNumber ? 0 : self.visibleSlide + 1
          self.showNewSlide()
        }, 10000)
        $(self.element).removeAttr('data-delay')
      }, $(this.element).attr('data-delay'))
    } else {
      const sliderInterval = $(self.element).attr('data-interval')
        ? Number($(self.element).attr('data-interval'))
        : 10000
      this.intervalID = setInterval(function () {
        self.oldVisibleSlide = self.visibleSlide
        self.visibleSlide = self.visibleSlide + 1 == self.slidesNumber ? 0 : self.visibleSlide + 1
        self.showNewSlide()
      }, sliderInterval)
    }
  }
}

heroSlider.prototype.showNewSlide = function () {
  const self = this
  this.updateDownload()
  clearInterval(this.intervalID)
  classie.add(this.slides[this.visibleSlide], 'selected')
  classie.add(this.slides[this.visibleSlide], 'animate-box')
  classie.remove(this.slides[this.visibleSlide], 'move-left')
  classie.remove(this.slides[this.visibleSlide], 'visible')

  if (this.oldVisibleSlide != this.visibleSlide) {
    classie.add(this.slides[this.oldVisibleSlide], 'visible')
    classie.remove(this.slides[this.oldVisibleSlide], 'selected')
  }
  if (this.oldVisibleSlide < this.visibleSlide) classie.add(this.slides[this.oldVisibleSlide], 'move-left')

  if (this.controls) {
    classie.remove(this.controlsBtn[this.oldVisibleSlide], 'selected')
    classie.add(this.controlsBtn[this.visibleSlide], 'selected')
  }

  setTimeout(function () {
    for (let i = 0; i < self.slidesNumber; i++) {
      // classie.remove(self.slides[i], 'animate-box');
      if (i < self.visibleSlide && i != self.oldVisibleSlide) {
        classie.add(self.slides[i], 'move-left')
        classie.remove(self.slides[i], 'selected')
        classie.remove(self.slides[i], 'visible')
        if (self.controls) classie.remove(self.controlsBtn[i], 'selected')
      } else if (i > self.visibleSlide && i != self.oldVisibleSlide) {
        classie.remove(self.slides[i], 'move-left')
        classie.remove(self.slides[i], 'visible')
        classie.remove(self.slides[i], 'selected')
        if (self.controls) classie.remove(self.controlsBtn[i], 'selected')
      }
    }
    self.initAutoplay()
    if (classie.has(self.slidesWrapper, 'lazy-gallery')) self.loadImages()
  }, 50)

  if (this.slides[this.visibleSlide].getAttribute('data-type') == 'video') this.loadBgVideo()
  if (this.slides[this.oldVisibleSlide].querySelector('video') !== null)
    this.slides[this.oldVisibleSlide].querySelector('video').pause()
}

heroSlider.prototype.updateDownload = function () {
  if (this.downloadBtn) {
    this.downloadBtn.setAttribute('href', this.slides[this.visibleSlide].getAttribute('data-image'))
  }
}

heroSlider.prototype.loadImages = function () {
  this.loadSingleImage(this.slides[this.visibleSlide])

  const nextVisible = this.getSiblingVisible('next', this.visibleSlide)
  const prevVisible = this.getSiblingVisible('prev', this.visibleSlide)
  this.loadSingleImage(this.slides[nextVisible])
  this.loadSingleImage(this.slides[prevVisible])
}

heroSlider.prototype.getSiblingVisible = function (direction, index) {
  let newIndex = direction == 'prev' ? index - 1 : index + 1
  if (index < 0) newIndex = this.slidesNumber - 1
  if (index >= this.slidesNumber) newIndex = 0

  if (!$(this.slides[index]).is(':visible')) {
    newIndex = this.getSiblingVisible(direction, index)
  }

  return newIndex
}

heroSlider.prototype.loadSingleImage = function (slide) {
  //upload background image
  if (!classie.has(slide, 'loaded')) {
    const self = this
    const imageUrl = slide.getAttribute('data-image')
    //you need this to check if the image sprite has been loaded
    $('<img/>')
      .attr('src', imageUrl)
      .on('load', function () {
        $(this).remove()
        setTimeout(function () {
          classie.add(slide, 'loaded')
          !classie.has(self.element, 'photos')
            ? slide.querySelector('.image-wrapper').setAttribute('style', `background-image: url(${imageUrl});`)
            : slide.querySelector('img').setAttribute('src', imageUrl)
        }, 400)
      })
  }
}

heroSlider.prototype.loadBgVideo = function () {
  const mq = checkMq()
  const visibleSlide = this.slides[this.visibleSlide]

  if (mq != 'mobile' && visibleSlide.querySelector('video') == null) {
    const bgVideo = document.createElement('div')
    const videoPath = visibleSlide.getAttribute('data-source')
    const bgVideoContent = `<video loop muted><source src="${videoPath}" type="video/mp4">`
    bgVideo.setAttribute('class', 'bg-video-wrapper')
    bgVideo.innerHTML = bgVideoContent
    visibleSlide.insertBefore(bgVideo, visibleSlide.querySelector('.content'))
  }

  if (mq != 'mobile') visibleSlide.querySelector('video').play()
}

heroSlider.prototype.initSlider = function () {
  const self = this
  if (classie.has(this.element, 'filter-gallery-popup') || classie.has(this.element, 'js-no-filter-gallery-popup')) {
    const galleryTrigger = document.getElementsByClassName('gallery-image-previews')[0]
    galleryTrigger.addEventListener('click', function (event) {
      if (event.target.tagName.toLowerCase == 'a' || getAncestor(event.target, 'gallery-image-previews')) {
        event.preventDefault()
        const listItem = getAncestor(event.target, 'single-item')
        const indexListItem = elementIndex(listItem)
        self.visibleSlide = indexListItem
        self.oldVisibleSlide = indexListItem
        // if( indexListItem > 1 ) self.oldVisibleSlide = indexListItem - 1;
        self.showNewSlide()
        classie.add(self.element, 'is-visible')
        setTimeout(function () {
          classie.remove(self.element, 'no-transition')
        }, 300)
      }
    })
  }
}

heroSlider.prototype.showInitialSlide = function (index, type) {
  const self = this
  this.visibleSlide = index
  this.oldVisibleSlide = index
  this.showNewSlide()

  if (type == 'open') {
    classie.add($(self.element)[0], 'is-visible')
  }

  setTimeout(function () {
    classie.remove(self.element, 'no-transition')
  }, 300)
}

const heroSliders = document.getElementsByClassName('hero-slider')
if (heroSliders) {
  for (let i = 0; i < heroSliders.length; i++) {
    ;(function (i) {
      new heroSlider(heroSliders[i])
    })(i)
  }
}

/*
    articles slider
  */

function articleSlider(element) {
  this.element = element
  this.articles = this.element.querySelector('.article-excerpt').querySelectorAll('li')
  this.images = this.element.querySelector('.article-images').querySelectorAll('li')
  this.navigation = this.element.querySelector('.articles-navigation')
  this.visibleSlide = 0

  this.updateSlide()
}

articleSlider.prototype.updateSlide = function () {
  const self = this

  this.navigation.addEventListener('click', function (event) {
    event.preventDefault()
    if (event.target.tagName.toLowerCase() == 'a' && !classie.has(event.target, 'inactive')) {
      classie.has(event.target, 'next') ? self.nextArticle() : self.prevArticle()
    }
  })

  //swipe effect using jQuery mobile
  const $articleImagesWrap = $(this.element).children('.article-images')
  const $articleExcerptWrap = $(this.element).children('.article-excerpt')
  $articleImagesWrap.add($articleExcerptWrap).on('swipeleft', function () {
    if (!classie.has(self.navigation.querySelector('.next'), 'inactive')) {
      self.nextArticle()
    }
  })

  $articleImagesWrap.on('swiperight', function () {
    if (!classie.has(self.navigation.querySelector('.prev'), 'inactive')) {
      self.prevArticle()
    }
  })
}

articleSlider.prototype.nextArticle = function () {
  const self = this
  classie.add(self.articles[self.visibleSlide + 1], 'selected')
  classie.add(self.images[self.visibleSlide + 1], 'selected')
  classie.remove(self.articles[self.visibleSlide], 'selected')
  classie.add(self.articles[self.visibleSlide], 'move-left')
  classie.remove(self.images[self.visibleSlide], 'selected')
  classie.add(self.images[self.visibleSlide], 'move-left')
  self.visibleSlide = self.visibleSlide + 1
  self.updateArticleNav()
}

articleSlider.prototype.prevArticle = function () {
  const self = this
  classie.add(self.articles[self.visibleSlide - 1], 'selected')
  classie.remove(self.articles[self.visibleSlide - 1], 'move-left')
  classie.add(self.images[self.visibleSlide - 1], 'selected')
  classie.remove(self.images[self.visibleSlide - 1], 'move-left')
  classie.remove(self.articles[self.visibleSlide], 'selected')
  classie.remove(self.images[self.visibleSlide], 'selected')
  self.visibleSlide = self.visibleSlide - 1
  self.updateArticleNav()
}

articleSlider.prototype.updateArticleNav = function () {
  const self = this
  self.visibleSlide == 0
    ? classie.add(self.navigation.querySelector('.prev'), 'inactive')
    : classie.remove(self.navigation.querySelector('.prev'), 'inactive')
  self.visibleSlide >= self.articles.length - 1
    ? classie.add(self.navigation.querySelector('.next'), 'inactive')
    : classie.remove(self.navigation.querySelector('.next'), 'inactive')
}

const articleSliders = document.getElementsByClassName('articles')
if (articleSliders) {
  for (let i = 0; i < articleSliders.length; i++) {
    ;(function (i) {
      new articleSlider(articleSliders[i])
    })(i)
  }
}

/*
    instagram slider
  */

function instagramSlider(element) {
  this.element = element
  this.slider = this.element.querySelector('.instagram-images')
  this.navigation = this.element.querySelector('.instagram-navigation')

  this.updateSlide()
}

instagramSlider.prototype.updateSlide = function () {
  const self = this
  this.navigation.addEventListener('click', function (event) {
    if (event.target.tagName.toLowerCase() == 'a') {
      event.preventDefault()
      let newTranslateValue = self.slider.querySelector('li').offsetWidth
      const actualTranslateValue = getTranslateXValue(self.slider)
      newTranslateValue = classie.has(event.target, 'next')
        ? actualTranslateValue - newTranslateValue
        : actualTranslateValue + newTranslateValue
      if (newTranslateValue > 0) newTranslateValue = 0
      if (newTranslateValue <= -self.slider.offsetWidth + self.element.offsetWidth)
        newTranslateValue = -self.slider.offsetWidth + self.element.offsetWidth
      setTransformValue(self.slider, 'translateX', `${newTranslateValue}px`)
      newTranslateValue == 0 ? classie.remove(self.element, 'prev-active') : classie.add(self.element, 'prev-active')
      newTranslateValue == -self.slider.offsetWidth + self.element.offsetWidth
        ? classie.remove(self.element, 'next-active')
        : classie.add(self.element, 'next-active')
    }
  })
}

const instagramSliders = document.getElementsByClassName('instagram-slider')
if (instagramSliders) {
  for (let i = 0; i < instagramSliders.length; i++) {
    ;(function (i) {
      new instagramSlider(instagramSliders[i])
    })(i)
  }
}

/*
    instagram feeds
  */
const usernames = ['lodekingind']
if ($('.instagram-images').length > 0) {
  const instagramImages = $('.instagram-images')
  $.ajax({
    type: 'GET',
    dataType: 'jsonp',
    cache: false,
    url: 'https://api.instagram.com/v1/users/2258018586/media/recent/?access_token=2258018586.cd47878.515f60c939914f5a9dc643c433470f16&count=10',
    success: function (data) {
      $.each(data.data, function (i) {
        if ($.inArray(data.data[i].user.username, usernames) >= -1) {
          instagramImages.append(
            `<li><a target='_blank' href='${data.data[i].link}'><img src='${data.data[i].images.standard_resolution.url}' /></a></li>`
          )
          instagramImages.parents('.instagram').removeClass('hidden')
        }
      })
      instagramImages.append(
        "<li class='see-all'><a target='_blank' href='https://www.instagram.com/lodekingind/'><span>See more photos on Instagram</span></a></li>"
      )
    },
  })
}

/*
    Accordion
  */

const accordions = $('.js-accordion')
if (accordions.length > 0) {
  accordions.each(function () {
    const accordion = $(this)
    accordion.on('click', '.js-header', function (event) {
      event.preventDefault()
      const selectedLi = $(this).parent()
      selectedLi.hasClass('active')
        ? selectedLi.removeClass('active').children('.accordion-content').attr('style', 'display:block;').slideUp(200)
        : selectedLi.addClass('active').children('.accordion-content').attr('style', 'display:none;').slideDown(200)
    })
  })
}

/*
    Photo Contest - Selected Strutta page
  */

const struttaApp = $('.js-strutta-app')
if (struttaApp.length > 0) {
  const photoContestSubNav = $('.js-photo-contest-subnav')
  photoContestSubNav.on('click', 'a', function () {
    if (!$(this).parent().is('.placeholder')) {
      photoContestSubNav.find('.active').removeClass('active')
      const textSelected = $(this).text()
      $(this).addClass('active')
      photoContestSubNav.find('.placeholder').children('a').text(textSelected).data('type', textSelected)
      photoContestSubNav.parent().removeClass('is-open')
    }
  })
}

/*
    filter - configuration slider
  */
function contentFilter(element) {
  this.element = element
  if (!this.element.querySelector('.js-filter-nav')) {
    return false
  }
  this.filterNav = this.element.querySelector('.js-filter-nav').querySelector('ul')
  this.navItems = this.filterNav.querySelectorAll('a')
  this.filterContent = this.element.querySelector('.filter-content')
  if (classie.has(this.element, 'has-popup')) {
    this.popup = document.getElementsByClassName('filter-gallery-popup')[0]
  }

  this.initFilter()
}

contentFilter.prototype.initFilter = function () {
  const self = this
  this.filterNav.addEventListener('click', function (event) {
    if (classie.has(event.target.parentElement, 'placeholder')) {
      event.preventDefault()
      classie.toggle(self.filterNav.parentElement, 'is-open')
      self.navItems[0].textContent == self.navItems[0].getAttribute('data-type')
        ? (self.navItems[0].textContent = 'Select')
        : (self.navItems[0].textContent = self.navItems[0].getAttribute('data-type'))
    } else if (event.target.tagName.toLowerCase() == 'a' && !classie.has(event.target, 'active')) {
      if (!$(self.filterNav).hasClass('js-filter-redirect')) {
        event.preventDefault()
        self.updateContent(event.target)
      }
    } else if (
      event.target.parentElement.tagName.toLowerCase() == 'a' &&
      !classie.has(event.target.parentElement, 'active')
    ) {
      if (!$(self.filterNav).hasClass('js-filter-redirect')) {
        event.preventDefault()
        self.updateContent(event.target.parentElement)
      }
    } else if (event.target.tagName.toLowerCase() == 'a' && classie.has(event.target, 'active')) {
      if (!$(self.filterNav).hasClass('js-filter-redirect')) {
        event.preventDefault()
        self.navItems[0].textContent = self.navItems[0].getAttribute('data-type')
        classie.remove(self.filterNav.parentElement, 'is-open')
      }
    }
  })

  if (this.filterContent && classie.has(this.filterContent, 'slider-filter')) {
    this.filterContent.addEventListener('click', function (event) {
      if (event.target.tagName.toLowerCase() == 'a' || event.target.parentElement.tagName.toLowerCase() == 'a') {
        const selectedContentIndex = elementIndex(getAncestor(event.target, 'filter-item'))
        const actualContentIndex = elementIndex(self.filterNav.querySelector('.active').parentElement) - 1
        if (selectedContentIndex != actualContentIndex) {
          event.preventDefault()
          self.updateContent(self.navItems[selectedContentIndex + 1])
        }
      }
    })

    $(this.filterContent).on('swipeleft', function () {
      const activeFilter = self.filterNav.querySelector('.active').parentElement
      if (activeFilter.nextElementSibling) self.updateContent(activeFilter.nextElementSibling.querySelector('a'))
    })

    $(this.filterContent).on('swiperight', function () {
      const activeFilter = self.filterNav.querySelector('.active').parentElement
      if (activeFilter.previousElementSibling && !classie.has(activeFilter.previousElementSibling, 'placeholder'))
        self.updateContent(activeFilter.previousElementSibling.querySelector('a'))
    })
  }
}

contentFilter.prototype.updateContent = function (target) {
  this.resetNav(elementIndex(target.parentElement))
  this.navItems[0].textContent = target.textContent
  this.navItems[0].setAttribute('data-type', target.textContent)
  classie.remove(this.filterNav.parentElement, 'is-open')

  if ($(this.element).hasClass('js-filter-list')) {
    this.updateListItems(target)
  } else {
    const selectedContent = target.hash.replace('#', '')
    this.filterContent.setAttribute('data-filter', selectedContent)

    if (this.popup) this.checkPopup(selectedContent)
  }
}

contentFilter.prototype.updateListItems = function (selectedItem) {
  const filter = $(selectedItem).data('id')
  if (filter == 'all') {
    $(this.filterContent).find('.js-item').removeAttr('style')
  } else {
    $(this.filterContent).find(`.js-item:not(.${filter})`).hide()
    $(this.filterContent).find(`.js-item.${filter}`).show()
  }

  if ($(this.filterContent).hasClass('js-open-popup-filter')) {
    if (filter == 'all') {
      $(`.js-gallery-popup[data-popup="${$(this.filterContent).data('popup')}"]`)
        .find('.js-item')
        .removeAttr('style')
    } else {
      $(`.js-gallery-popup[data-popup="${$(this.filterContent).data('popup')}"]`)
        .find(`.js-item:not(.${filter})`)
        .hide()
      $(`.js-gallery-popup[data-popup="${$(this.filterContent).data('popup')}"]`)
        .find(`.js-item.${filter}`)
        .show()
    }
  }
}

contentFilter.prototype.resetNav = function (index) {
  for (let i = 0; i < this.navItems.length; i++) {
    i == index ? classie.add(this.navItems[i], 'active') : classie.remove(this.navItems[i], 'active')
  }
}

contentFilter.prototype.checkPopup = function (selectedContent) {
  //this is only if a popup is associated to the filter gallery
  this.popup.setAttribute('data-filter', selectedContent)
}

const filters = document.getElementsByClassName('filter')
if (filters) {
  for (let i = 0; i < filters.length; i++) {
    ;(function (i) {
      new contentFilter(filters[i])
    })(i)
  }
}

/*
    POPUP Video
  */
const videoLink = document.getElementsByClassName('open-video')
const videoPopup = document.getElementsByClassName('video-popup')[0]
if (videoLink) {
  for (let i = 0; i < videoLink.length; i++) {
    ;(function (i) {
      videoLink[i].addEventListener('click', function (event) {
        event.preventDefault()
        openVideo(this.getAttribute('data-video'))
      })
    })(i)
  }

  const queryString = {}
  window.location.href.replace(new RegExp('([^?=&]+)(=([^&]*))?', 'g'), function ($0, $1, $2, $3) {
    queryString[$1] = $3
  })

  if (queryString['video']) {
    const videoUrl = document.getElementById(queryString['video']).getAttribute('data-video')
    videoPopup.querySelector('iframe').setAttribute('src', videoUrl)
    classie.add(videoPopup, 'is-visible')
  }
}

function openVideo(videoUrl) {
  videoPopup.querySelector('iframe').setAttribute('src', videoUrl)
  classie.add(videoPopup, 'is-visible')
}

const gallerySlider = document.getElementsByClassName('js-gallery-popup')
if (gallerySlider) {
  for (let i = 0; i < gallerySlider.length; i++) {
    ;(function (i) {
      new heroSlider(gallerySlider[i])
    })(i)
  }
}

/*
  Brochure popup/quote popup
*/
$(document).on('click', '.js-open-popup', function (event) {
  event.preventDefault()
  const popupId = $(this).attr('data-popup-id')
  const popup = $(`[data-popup="${popupId}"]`)

  // Add CSS class once transition is complete
  $(document).one('transitionend', '.overlay-popup', function () {
    $(this).addClass('is-open')
  })

  popup.addClass('is-visible')
  if ($(this).hasClass('js-form-popup')) {
    popup.attr('style', `top: ${$(window).scrollTop()}px;`)
    $('.js-form-popup-background').addClass('is-visible')
  }
})

const popupFormBgLayer = document.getElementsByClassName('js-form-popup-background')

if (popupFormBgLayer) {
  for (let i = 0; i < popupFormBgLayer.length; i++) {
    ;(function (i) {
      popupFormBgLayer[i].addEventListener('click', function () {
        const popup = document.querySelector('.overlay-popup.is-visible')
        classie.remove(popupFormBgLayer[i], 'is-visible')
        classie.remove(popup, 'is-visible')
      })
    })(i)
  }
}

/*
    Close overlay popups
  */
const popups = document.getElementsByClassName('overlay-popup')
if (popups) {
  for (let i = 0; i < popups.length; i++) {
    ;(function (i) {
      popups[i].addEventListener('click', function (event) {
        if (classie.has(event.target, 'overlay-popup') || classie.has(event.target, 'close-popup')) {
          event.preventDefault()
          classie.remove(this, 'is-visible')
          if (classie.has(this, 'video-popup')) this.querySelector('iframe').removeAttribute('src')
          if (classie.has(this, 'js-gallery-popup')) classie.add(this, 'no-transition')
          if (classie.has(this, 'form-popup'))
            classie.remove(document.querySelector('.js-form-popup-background'), 'is-visible')
        }
      })
    })(i)
  }

  //close modal window width escale key
  document.addEventListener('keyup', function (event) {
    if (event.keyCode == 27) {
      classie.remove(document.getElementsByClassName('is-visible')[0], 'is-visible')
    }
  })
}

/*
    Gallery popup
  */

const galleryLink = document.getElementsByClassName('open-gallery')
if (galleryLink) {
  for (let i = 0; i < galleryLink.length; i++) {
    ;(function (i) {
      galleryLink[i].addEventListener('click', function (event) {
        event.preventDefault()
        const galleryPopupId = event.target.hash.replace('#', '')
        const galleryPopup = document.getElementById(galleryPopupId)
        classie.add(galleryPopup, 'is-visible')
      })
    })(i)
  }
}

const productBuilder = document.getElementById('product-builder')

if (!productBuilder) {
  const productToursWrappers = $('.product-viewer-wrapper')
  if (productToursWrappers.length > 0) {
    productToursWrappers.each(function () {
      const direction = $(this).data('direction') || 'cw'
      new productViewer($(this), direction)
    })
  }
}

/*
    Points of interest - features page
  */
const pointsWrapper = document.getElementsByClassName('interest-points')
if (pointsWrapper) {
  for (let i = 0; i < pointsWrapper.length; i++) {
    ;(function (i) {
      pointsWrapper[i].addEventListener('click', function (event) {
        //open/close interest point description
        if (event.target.tagName.toLowerCase() == 'a' && classie.has(event.target.parentElement, 'single-point')) {
          event.preventDefault()
          if (classie.has(event.target.parentElement, 'is-open')) {
            classie.remove(event.target.parentElement, 'is-open')
            classie.add(event.target.parentElement, 'visited')
          } else {
            classie.add(event.target.parentElement, 'is-open')
            const siblings = getSiblings(event.target.parentElement)
            for (let j = 0; j < siblings.length; j++) classie.remove(siblings[j], 'is-open')
          }
        } else if (event.target.tagName.toLowerCase() == 'a' && classie.has(event.target, 'close-point-info')) {
          event.preventDefault()
          const pointParent = getAncestor(event.target, 'single-point')
          classie.remove(pointParent, 'is-open')
          classie.add(pointParent, 'visited')
        }
      })
    })(i)
  }
}

/*
    product category page
  */

const modelsOverview = document.getElementsByClassName('js-sub-cat-overview')[0]
if (modelsOverview) {
  modelsOverview.addEventListener('click', function (event) {
    if (classie.has(event.target, 'js-show-models')) {
      event.preventDefault()
      const singleModel = getAncestor(event.target, 'js-single-model')
      classie.add(singleModel, 'model-visible')
    } else if (classie.has(event.target, 'js-close-models')) {
      event.preventDefault()
      const singleModel = getAncestor(event.target, 'js-single-model')
      classie.remove(singleModel, 'model-visible')
    }
  })
}

/*
    about page - company page - timeline
  */

const $timelineBlocks = $('.timeline-block')
const offset = 0.8
let timelineScrolling = false

if ($timelineBlocks.length > 0) {
  //hide timeline blocks which are outside the viewport
  hideBlocks($timelineBlocks, offset)

  //on scolling, show/animate timeline blocks when enter the viewport
  $(window).on('scroll', function () {
    timelineScrolling = debounce(!timelineScrolling, timelineScrolling, function () {
      showBlocks($timelineBlocks, offset)
    })
  })
}

function hideBlocks(blocks, offset) {
  blocks.each(function () {
    $(this).offset().top > $(window).scrollTop() + $(window).height() * offset &&
      $(this).find('.timeline-img, .timeline-content').addClass('is-hidden')
  })
}

function showBlocks(blocks, offset) {
  blocks.each(function () {
    $(this).find('.timeline-img').hasClass('is-hidden') &&
      $(this).offset().top <= $(window).scrollTop() + $(window).height() * offset &&
      $(this).find('.timeline-img, .timeline-content').removeClass('is-hidden').addClass('bounce-in')
  })
  timelineScrolling = false
}

/*
    Blog page
  */
const blogSecondaryNav = document.getElementsByClassName('blog-secondary-nav')[0]
let blogResizing = false
if (blogSecondaryNav) {
  const blogCategories = document.getElementsByClassName('blog-categories')[0]
  const closeBlogCategories = document.getElementsByClassName('close-categories')[0]

  blogSecondaryNav.addEventListener('click', function (event) {
    if (
      classie.has(event.target, 'js-category-placeholder') ||
      classie.has(event.target.parentElement, 'js-category-placeholder')
    ) {
      event.preventDefault()
      classie.add(blogCategories, 'categories-open')
      classie.add(closeBlogCategories, 'categories-open')
    } else if (
      classie.has(event.target, 'js-blog-search') ||
      classie.has(event.target.parentElement, 'js-blog-search')
    ) {
      event.preventDefault()
      if (classie.has(blogSecondaryNav, 'search-is-visible')) {
        classie.remove(blogSecondaryNav, 'search-is-visible')
      } else {
        classie.add(blogSecondaryNav, 'search-is-visible')
        setTimeout(function () {
          blogSecondaryNav.querySelector('.js-search').focus()
        }, 200)
      }
    }
  })

  closeBlogCategories.addEventListener('click', function (event) {
    event.preventDefault()
    classie.remove(blogCategories, 'categories-open')
    classie.remove(closeBlogCategories, 'categories-open')
  })
  //move blog categories list according to window width
  moveBlogCategories(blogCategories, closeBlogCategories)
  window.addEventListener('resize', function () {
    blogResizing = debounce(!blogResizing, blogResizing, moveBlogCategories)
  })
}

function moveBlogCategories(categories, closeCategories) {
  const mq = checkMq()
  const mainBlog = document.getElementsByClassName('main-blog')[0]
  const blogSearch = blogSecondaryNav.querySelector('.blog-search')
  categories.remove()
  closeCategories.remove()
  if (mq == 'desktop') {
    blogSecondaryNav.insertBefore(closeCategories, blogSearch)
    blogSecondaryNav.insertBefore(categories, closeCategories)
  } else {
    mainBlog.insertBefore(closeCategories, blogSecondaryNav)
    mainBlog.insertBefore(categories, closeCategories)
  }

  blogResizing = false
}

/*
    contact page - location map
  */
const locationMap = document.getElementById('location-map')
if (locationMap) {
  const style = getMapStyle()
  const markerUrl = getMapMarker('pin-contact-map')

  const mapOptions = {
    center: new google.maps.LatLng(49.175539, -97.92139),
    zoom: 14,
    panControl: false,
    streetViewControl: false,
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    scrollwheel: false,
    styles: style,
  }

  //inizialize the map
  const map = new google.maps.Map(locationMap, mapOptions)
  // eslint-disable-next-line
  var marker = new google.maps.Marker({
    position: new google.maps.LatLng(49.175539, -97.92139),
    map: map,
    visible: true,
    icon: markerUrl,
  })
}

/*
    Testimonial slider
  */

const testimonialSlider = function (element) {
  this.element = element
  this.slider = this.element.querySelector('.js-slider')
  this.slides = this.slider.querySelectorAll('.js-slide')
  this.slidesNumber = this.slides.length
  this.visibleIndex = 0
  this.navigation = this.element.querySelector('.js-slider-navigation')
  this.animating = false
  this.bindEvents()
}

testimonialSlider.prototype.bindEvents = function () {
  const self = this

  this.navigation.addEventListener('click', function (event) {
    if (!self.animating) {
      self.animating = true
      event.preventDefault()

      const direction = classie.has(event.target, 'next') ? 'next' : 'prev'
      self.updateSlide(direction)
    }
  })

  $(this.element).on('swipeleft', function () {
    self.updateSlide('next')
  })
  $(this.element).on('swiperight', function () {
    self.updateSlide('prev')
  })
}

testimonialSlider.prototype.updateSlide = function (direction) {
  const slideToHideIndex = this.visibleIndex
  const self = this
  if (direction == 'next') {
    this.visibleIndex = this.visibleIndex + 1 <= this.slidesNumber - 1 ? this.visibleIndex + 1 : 0
    classie.remove(this.slides[this.visibleIndex], 'prev')
  } else {
    this.visibleIndex = this.visibleIndex - 1 >= 0 ? this.visibleIndex - 1 : this.slidesNumber - 1
    classie.add(this.slides[this.visibleIndex], 'prev')
  }

  setTimeout(function () {
    classie.add(self.slides[self.visibleIndex], 'is-animating')
    classie.add(self.slides[slideToHideIndex], 'is-animating')
    classie.add(self.slides[self.visibleIndex], 'visible')
    classie.remove(self.slides[slideToHideIndex], 'visible')
    classie.remove(self.slides[self.visibleIndex], 'prev')
    direction == 'next'
      ? classie.add(self.slides[slideToHideIndex], 'prev')
      : classie.remove(self.slides[slideToHideIndex], 'prev')
    self.updateHeight()

    setTimeout(function () {
      classie.remove(self.slides[self.visibleIndex], 'is-animating')
      classie.remove(self.slides[slideToHideIndex], 'is-animating')
      self.animating = false
    }, 400)
  }, 20)
}

testimonialSlider.prototype.updateHeight = function () {
  const newHeight = this.slides[this.visibleIndex].offsetHeight

  this.slider.setAttribute('style', `height: ${newHeight}px;`)
}

//initialize the testimonial slider
const testimonialSliders = document.getElementsByClassName('js-testimonials')
if (testimonialSliders) {
  for (let i = 0; i < testimonialSliders.length; i++) {
    ;(function (i) {
      new testimonialSlider(testimonialSliders[i])
    })(i)
  }
}

//comparison table
function productsTable(element) {
  this.element = element
  this.table = this.element.children('.products-table')
  this.tableHeight = this.table.height()
  this.productsWrapper = this.table.children('.products-wrapper')
  this.tableColumns = this.productsWrapper.children('.products-columns')
  this.products = this.tableColumns.children('.product')
  this.productsNumber = this.products.length
  this.productWidth = this.products.eq(0).width()
  this.productsTopInfo = this.table.find('.top-info')
  this.featuresTopInfo = this.table.children('.features').children('.top-info')
  this.topInfoHeight = this.featuresTopInfo.innerHeight() + 30
  this.leftScrolling = false
  this.filterBtn = this.element.find('.compare-filter')
  this.resetBtn = this.element.find('.reset')
  ;(this.filtering = false), (this.selectedproductsNumber = 0)
  this.filterActive = false
  this.navigation = this.table.children('.table-navigation')
  // bind table events
  this.bindEvents()
}

productsTable.prototype.bindEvents = function () {
  const self = this
  //detect scroll left inside producst table
  self.productsWrapper.on('scroll', function () {
    if (!self.leftScrolling) {
      self.leftScrolling = true
      !window.requestAnimationFrame
        ? setTimeout(function () {
            self.updateLeftScrolling()
          }, 250)
        : window.requestAnimationFrame(function () {
            self.updateLeftScrolling()
          })
    }
  })
  //select single product to filter
  self.products.on('click', '.top-info', function () {
    const product = $(this).parents('.product')
    if (!self.filtering && product.hasClass('selected')) {
      product.removeClass('selected')
      self.selectedproductsNumber = self.selectedproductsNumber - 1
      self.upadteFilterBtn()
    } else if (!self.filtering && !product.hasClass('selected')) {
      product.addClass('selected')
      self.selectedproductsNumber = self.selectedproductsNumber + 1
      self.upadteFilterBtn()
    }
  })
  //filter products
  self.filterBtn.on('click', function (event) {
    event.preventDefault()
    if (self.filterActive) {
      self.filtering = true
      self.showSelection()
      self.filterActive = false
      self.filterBtn.removeClass('active')
    }
  })
  //reset product selection
  self.resetBtn.on('click', function (event) {
    event.preventDefault()
    if (self.filtering) {
      self.filtering = false
      self.resetSelection()
    } else {
      self.products.removeClass('selected')
    }
    self.selectedproductsNumber = 0
    self.upadteFilterBtn()
  })
  //scroll inside products table
  this.navigation.on('click', 'a', function (event) {
    event.preventDefault()
    self.updateSlider($(event.target).hasClass('next'))
  })
}

productsTable.prototype.upadteFilterBtn = function () {
  //show/hide filter btn
  if (this.selectedproductsNumber >= 2) {
    this.filterActive = true
    this.filterBtn.addClass('active')
  } else {
    this.filterActive = false
    this.filterBtn.removeClass('active')
  }
}

productsTable.prototype.updateLeftScrolling = function () {
  const scrollLeft = this.productsWrapper.scrollLeft()

  scrollLeft > 0 ? this.table.addClass('scrolling') : this.table.removeClass('scrolling')

  if (this.table.hasClass('top-fixed') && checkMq() == 'desktop') {
    setTranformX(this.productsTopInfo, `-${scrollLeft}`)
    setTranformX(this.featuresTopInfo, '0')

    // setTransformValue(this.productsTopInfo[0], 'translateX','-'+scrollLeft+'px');
    // setTransformValue(this.featuresTopInfo[0], 'translateX', '0px');
  } else {
    setTranformX(this.productsTopInfo, '0')
    setTranformX(this.featuresTopInfo, '0')
  }

  this.leftScrolling = false

  this.updateNavigationVisibility(scrollLeft)
}

productsTable.prototype.updateNavigationVisibility = function (scrollLeft) {
  scrollLeft > 0
    ? this.navigation.find('.prev').removeClass('inactive')
    : this.navigation.find('.prev').addClass('inactive')

  if (
    scrollLeft < this.tableColumns.outerWidth(true) - this.productsWrapper.width() &&
    this.tableColumns.outerWidth(true) > this.productsWrapper.width()
  ) {
    this.navigation.find('.next').removeClass('inactive')
    this.table.removeClass('table-end')
  } else {
    this.navigation.find('.next').addClass('inactive')
    this.table.addClass('table-end')
  }
}

productsTable.prototype.updateTopScrolling = function (scrollTop) {
  const offsetTop = this.table.offset().top
  const headerHeight = mainHeader.offsetHeight

  if (
    offsetTop - headerHeight <= scrollTop &&
    offsetTop + this.tableHeight - this.topInfoHeight - headerHeight >= scrollTop
  ) {
    //fix products top-info && arrows navigation
    if (!this.table.hasClass('top-fixed') && $(document).height() > offsetTop + $(window).height() + 200) {
      this.table.addClass('top-fixed').removeClass('top-scrolling')
      if (checkMq() == 'desktop') {
        this.productsTopInfo.css('top', `${headerHeight}px`)
        this.navigation.find('a').css('top', `${headerHeight}px`)
      }
    }
  } else if (offsetTop - headerHeight <= scrollTop) {
    //product top-info && arrows navigation -  scroll with table
    this.table.removeClass('top-fixed').addClass('top-scrolling')
    if (checkMq() == 'desktop') {
      this.productsTopInfo.css('top', `${this.tableHeight - this.topInfoHeight}px`)
      this.navigation.find('a').css('top', `${this.tableHeight - this.topInfoHeight}px`)
    }
  } else {
    //product top-info && arrows navigation -  reset style
    this.table.removeClass('top-fixed top-scrolling')
    this.productsTopInfo.attr('style', '')
    this.navigation.find('a').attr('style', '')
  }

  this.updateLeftScrolling()
}

productsTable.prototype.updateProperties = function () {
  this.tableHeight = this.table.height()
  this.productWidth = this.products.eq(0).width()
  this.topInfoHeight = this.featuresTopInfo.innerHeight() + 30
  this.tableColumns.css('width', `${this.productWidth * this.productsNumber}px`)
}

productsTable.prototype.showSelection = function () {
  this.element.addClass('filtering')
  this.filterProducts()
}

productsTable.prototype.resetSelection = function () {
  this.tableColumns.css('width', `${this.productWidth * this.productsNumber}px`)
  this.element.removeClass('no-product-transition')
  this.resetProductsVisibility()
}

productsTable.prototype.filterProducts = function () {
  const self = this
  const containerOffsetLeft = self.tableColumns.offset().left
  const scrollLeft = self.productsWrapper.scrollLeft()
  const selectedProducts = this.products.filter('.selected')
  const numberProducts = selectedProducts.length

  selectedProducts.each(function (index) {
    const product = $(this)
    const leftTranslate = containerOffsetLeft + index * self.productWidth + scrollLeft - product.offset().left
    setTranformX(product, leftTranslate)
    // setTransformValue(product[0], 'translateX', leftTranslate+'px');

    if (index == numberProducts - 1) {
      product.one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function () {
        setTimeout(function () {
          self.element.addClass('no-product-transition')
        }, 50)
        setTimeout(function () {
          self.element.addClass('filtered')
          self.productsWrapper.scrollLeft(0)
          self.tableColumns.css('width', `${self.productWidth * numberProducts}px`)
          selectedProducts.attr('style', '')
          product.off('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend')
          self.updateNavigationVisibility(0)
        }, 100)
      })
    }
  })

  if ($('.no-csstransitions').length > 0) {
    //browser not supporting css transitions
    self.element.addClass('filtered')
    self.productsWrapper.scrollLeft(0)
    self.tableColumns.css('width', `${self.productWidth * numberProducts}px`)
    selectedProducts.attr('style', '')
    self.updateNavigationVisibility(0)
  }
}

productsTable.prototype.resetProductsVisibility = function () {
  const self = this
  const selectedProducts = this.products.filter('.selected')
  let n = 0

  self.element.addClass('no-product-transition').removeClass('filtered')

  self.products.each(function (index) {
    const product = $(this)
    if (product.hasClass('selected')) {
      n = n + 1
      const leftTranslate = (-index + n - 1) * self.productWidth
      setTranformX(product, leftTranslate)

      // setTransformValue(product[0], 'translateX', leftTranslate+'px');
    }
  })

  setTimeout(function () {
    self.element.removeClass('no-product-transition filtering')
    setTranformX(selectedProducts, '0')

    // setTransformValue(selectedProducts, 'translateX', '0px');
    selectedProducts.removeClass('selected').attr('style', '')
  }, 50)
}

productsTable.prototype.updateSlider = function (bool) {
  let scrollLeft = this.productsWrapper.scrollLeft()
  scrollLeft = bool ? scrollLeft + this.productWidth : scrollLeft - this.productWidth

  if (scrollLeft < 0) scrollLeft = 0
  if (scrollLeft > this.tableColumns.outerWidth(true) - this.productsWrapper.width())
    scrollLeft = this.tableColumns.outerWidth(true) - this.productsWrapper.width()

  this.productsWrapper.animate({ scrollLeft: scrollLeft }, 200)
}

const comparisonTables = []
let comparisonScrolling = false
let comparisonResize = false
if ($('.products-comparison-table').length > 0) {
  $('.products-comparison-table').each(function () {
    //create a productsTable object for each .cd-products-comparison-table
    comparisonTables.push(new productsTable($(this)))
  })

  //detect window scroll - fix product top-info on scrolling
  $(window).on('scroll', function () {
    debounce(!comparisonScrolling, comparisonScrolling, checkScrolling)
  })

  //detect window resize - reset .cd-products-comparison-table properties
  $(window).on('resize', function () {
    debounce(!comparisonResize, comparisonResize, checkResize)
  })
}

function checkScrolling() {
  const scrollTop = $(window).scrollTop()
  comparisonTables.forEach(function (element) {
    element.updateTopScrolling(scrollTop)
  })

  comparisonScrolling = false
}

function checkResize() {
  comparisonTables.forEach(function (element) {
    element.updateProperties()
  })

  comparisonResize = false
}

function setTranformX(element, value) {
  element.css({
    '-moz-transform': `translateX(${value}px)`,
    '-webkit-transform': `translateX(${value}px)`,
    '-ms-transform': `translateX(${value}px)`,
    '-o-transform': `translateX(${value}px)`,
    transform: `translateX(${value}px)`,
  })
}

/*
    Careers page / wufoo select position
  */

const careersPage = document.getElementsByClassName('js-careers-page')[0]
if (careersPage) {
  const careersForm = document.getElementsByClassName('js-careers-form')[0]
  const positionsList = document.getElementsByClassName('js-positions')[0]
  const positionField = '&field'

  positionsList.addEventListener('click', function () {
    if (classie.has(event.target, 'js-select-position')) {
      const selectedPositionId = event.target.getAttribute('data-id')
      const selectedPositionTitle = event.target.getAttribute('data-title')
      const wufooForm = careersForm.querySelector('iframe')
      const wufooFormSrc = wufooForm.getAttribute('src')
      const wufooFormSrcStart = wufooFormSrc.split(positionField)[0]

      wufooForm.setAttribute(
        'src',
        `${wufooFormSrcStart + positionField + selectedPositionId}=${selectedPositionTitle}`
      )
    }
  })
}

/*
    Video Gallery - Youtube
  */
function OnLoadCallback() {
  gapi.client.setApiKey('AIzaSyDdsbkrCQIfgMqevZirMoXTlD6U-dzHs1A')
  gapi.client.load('youtube', 'v3').then(extractVideoIds)
}

window.OnLoadCallback = OnLoadCallback

function extractVideoIds() {
  gapi.client.youtube.search
    .list({ part: 'snippet', channelId: 'UC2VWh8CVRme8u94CBWounwg', type: 'video', order: 'date', maxResults: 15 })
    .then(
      function (resp) {
        loadVideos(resp.result.items)
      },
      function () {
        videoList.parents('js-youtube-playlist').addClass('hidden')
      }
    )
}

function loadVideos(ids) {
  for (let i = 0; i < ids.length; i++) {
    const videoId = ids[i].id.videoId
    const videoTitle = ids[i].snippet.title
    const videoThumbnailUrl = ids[i].snippet.thumbnails.medium.url

    const lisItem = $(
      `<li><a href="#0" class="open-video" data-video="https://www.youtube.com/embed/${videoId}?autoplay=1"><div class="image"><img src="${videoThumbnailUrl}" alt="${videoTitle}"></div><div class="caption"><h3 class="no-border text-nowrap">${videoTitle}</h3></div></a></li>`
    )
    lisItem.appendTo(videoList)
    ;(function (videoId) {
      lisItem.children('a').on('click', function (event) {
        event.preventDefault()
        openVideo(`https://www.youtube.com/embed/${videoId}?autoplay=1`)
      })
    })(videoId)
  }
}

const youtubeGallery = document.getElementsByClassName('js-youtube-gallery')[0]
const videoList = youtubeGallery?.querySelector('.js-list')

/*
    Photo Contest - Archive page
  */

const photoContestArchivePopups = $('.js-photo-popup-photo-contest')
if (photoContestArchivePopups.length > 0) {
  photoContestArchivePopups.each(function () {
    const photoContestArchivePopup = $(this)

    const sliderList = photoContestArchivePopup.find('.js-slider-list')
    const imgPath = sliderList.data('path')
    const photContestList = $(`.js-photo-contest-wrapper[data-popup="${photoContestArchivePopup.data('popup')}"]`)
    let slides = ''
    photContestList.find('.js-item').each(function (index) {
      const className = index == 0 ? 'selected' : ''
      const anchor = $(this).children('a')
      const sliderItem = `<li data-image="${anchor.attr('href')}" class="js-item ${className} ${$(this).data(
        'filter'
      )}"><h3 class="text-nowrap">${anchor.attr('title')}</h3><div><img src="${imgPath}" alt="${anchor.attr(
        'title'
      )}"></div></li>`
      slides = slides + sliderItem
    })

    sliderList.html(slides)
    sliderList.trigger('sliderReady')

    photContestList.on('click', '.js-item', function (event) {
      event.preventDefault()
      const slideIndex = $(this).index()
      photoContestArchivePopup.trigger('openGallery', Number(slideIndex))
    })
  })
}

/*
    Load reviews -  reviews page
  */
if ($('.js-reviews').length > 0) {
  $('.js-reviews').each(function () {
    const reviewsWrapper = $(this)
    const reviewsList = reviewsWrapper.find('.js-reviews-list')
    const reviewsNumber = Number(reviewsWrapper.data('number'))

    $.ajax({
      type: 'POST',
      dataType: 'html',
      url: theme.ajax,
      data: {
        action: 'loadreviews',
        number: reviewsNumber,
      },
      beforeSend: function () {},
      success: function (data) {
        const reviews = jQuery.parseJSON(data)
        let listItems = ''

        if (reviews.length > 0) {
          for (let i = 0; i < reviews.length; i++) {
            let comment = reviews[i]['comment']
            const commentClass = ''
            const listItemClass = i == 0 ? 'selected' : ''
            let avatar = ''

            const date = new Date(reviews[i]['sent'] * 1000)
            if (reviews[i]['publishedavatar']) {
              avatar = `<img alt="user avatar" src="//static.asknice.ly${reviews[i]['publishedavatar']}">`
            } else {
              const initials = reviews[i]['name'].substring(0, 2).toUpperCase()
              avatar = `<span class="avatar-name">${initials}</span>`
            }

            comment = getCommentFormat(comment, reviewsList)

            listItems += `<li class="${listItemClass}"><div class="comment-wrapper"><p class="comment ${commentClass}">${comment}</p></div>`
            if (!reviewsWrapper.is('.js-reviews-text-only')) {
              listItems += getCommentAuthor(avatar, reviews[i]['name'], timeSince(date), reviewsList)
            }
            listItems += '</div></li>'
          }

          reviewsList.append(listItems)
          reviewsWrapper.addClass('reviews-loaded')
          if (reviewsList.is('.js-slider-list')) new heroSlider(reviewsWrapper.get(0))
        }
      },
      error: function () {
        // alert("Sorry, we could not load the required information.");
      },
    })
  })
}

function timeSince(date) {
  //return date in format 'X ago' (2weeks ago, 3days ago...)
  const seconds = Math.floor((new Date() - date) / 1000)

  let interval = Math.floor(seconds / 31536000)
  if (interval > 1) {
    return `${interval} years ago`
  }
  interval = Math.floor(seconds / 2592000)
  if (interval > 1) {
    return `${interval} months ago`
  }
  interval = Math.floor(seconds / 604800)
  if (interval > 1) {
    return `${interval} weeks ago`
  }
  interval = Math.floor(seconds / 86400)
  if (interval > 1) {
    return `${interval} days ago`
  }
  interval = Math.floor(seconds / 3600)
  if (interval > 1) {
    return `${interval} hours ago`
  }
  interval = Math.floor(seconds / 60)
  if (interval > 1) {
    return `${interval} minutes ago`
  }
  return `${Math.floor(seconds)} seconds ago`
}

function getCommentFormat(comment, list) {
  if (list.hasClass('js-home-reviews')) {
    // var commentClass = ''
    // if (comment.length < 60) {
    //   commentClass = 'font-xl';
    // } else if (comment.length < 100) {
    //    commentClass = 'font-l';
    // }

    if (comment.length > 120) {
      comment = `${comment.substr(0, 110)}...`
    }
  } else {
    let maxLength = 160
    if (list.data('max')) maxLength = Number(list.data('max'))
    if (comment.length > maxLength) {
      const fullComment = comment
      comment = comment.substr(0, maxLength - 10)
      if (!list.hasClass('js-no-full-review')) {
        comment = `${comment}<span class="more">...<span class="full-review">${fullComment}</span></span>`
      } else {
        comment = `${comment}...`
      }
    }
  }
  return comment
}

function getCommentAuthor(avatar, name, date, list) {
  let author
  if (list.hasClass('js-home-reviews')) {
    author = `<div class="review-user">${avatar}<div class="user-info"><span class="name">${name}</span><span class="date">${date}</span></div>`
  } else {
    author = `<div class="author author-info">${avatar}<div class="user-info"><span class="name text-nowrap">${name}</span><span class="date">${date}</span></div></div>`
  }

  return author
}

/*
		Sticky quicklinks
	*/
const stickyQuickLinks = $('.js-sticky-quick-links')
let quickLinksSticky = false
let quickLinksFixed = false
if (stickyQuickLinks.length > 0) {
  fixQuickLinks()

  $(window).on('scroll', function () {
    quickLinksFixed = debounce(!quickLinksFixed, quickLinksFixed, fixQuickLinks)
    quickLinksSticky = debounce(!quickLinksSticky, quickLinksSticky, makeQuickLinksSticky)
  })
}

function fixQuickLinks() {
  const offset = $(window).scrollTop() + $(window).height()
  stickyQuickLinks.each(function () {
    const stickyPrevElement = $(this).prev()

    if (stickyPrevElement.offset().top + stickyPrevElement.innerHeight() + $(this).innerHeight() - 270 > offset) {
      $(this).removeClass('scrolling')
    } else {
      $(this).addClass('scrolling')
      $(this).removeClass('fixed')
    }
    quickLinksFixed = false
  })
}

function makeQuickLinksSticky() {
  const offset = $(window).scrollTop() + $(window).height()
  const windowTop = $(window).scrollTop()
  const stickyPrevElement = stickyQuickLinks.prev()
  const mq = checkMq()

  if (
    mq == 'desktop' &&
    windowTop > 800 &&
    stickyPrevElement.offset().top + stickyPrevElement.innerHeight() + stickyQuickLinks.innerHeight() - 270 > offset
  ) {
    stickyQuickLinks.addClass('fixed')
  }

  if (mq == 'desktop' && windowTop < 800) {
    stickyQuickLinks.removeClass('fixed')
  }

  quickLinksSticky = false
}

/*
    Custom form - handle all forms *except* those on Product Builder pages
  */
const customForm = $('.js-custom-form')
if (customForm.length > 0 && !customForm.hasClass('js-is-builder-page')) {
  if ($(customForm).hasClass('js-load-dealers')) {
    loadDealers($(customForm).find('.js-dealers-list'))
  }
  customForm.on('submit', function (event) {
    const submittedForm = $(this)
    submittedForm.find(':submit').prop('disabled', true)
    event.preventDefault()

    checkRequiredFields($(this))
    if (submittedForm.find('.input-error').length == 0) {
      submittedForm.addClass('loading').removeClass('has-error').find('.input-error').removeClass('input-error')
      if (submittedForm.hasClass('js-brochure-request')) {
        sendBrochureRequest(submittedForm)
      } else if (submittedForm.hasClass('js-builder-quote')) {
        const dealerInfo = setDealerInfo(submittedForm)
        const selectedDealer = submittedForm.find('.js-dealers-list :selected')
        submitQuoteBuilder(
          submittedForm,
          dealerInfo,
          submittedForm.find('.js-dealers-list').val(),
          selectedDealer.attr('data-email'),
          selectedDealer.attr('data-manager'),
          selectedDealer.attr('data-id')
        )
      }
    } else {
      submittedForm.find(':submit').prop('disabled', false)
      submittedForm.addClass('has-error').find('.error-message').text('Please fill in all the required fields.')
    }
  })

  customForm.on('focus', '.input-error', function () {
    $(this).removeClass('input-error')
  })

  customForm.on('change', '.input-error.js-required-fields-wrapper', function () {
    $(this).removeClass('input-error')
  })

  //if the field with logic is a radio -> need to check change of all
  customForm.find('.js-logic-wrapper').each(function () {
    $(this).on('change', function () {
      const logicField = $(this).hasClass('js-logic') ? $(this) : $(this).find('.js-logic')
      logicField.each(function () {
        const fieldToToggle = customForm.find(`.${$(this).data('field')}`)
        fieldToToggle.toggle($(this).is(':checked'))
      })
    })
  })
}

function checkRequiredFields(form) {
  form.find('.js-required').each(function () {
    const value = $(this).val().replace(/ /g, '')
    !value ? $(this).addClass('input-error') : $(this).removeClass('input-error')

    //check if this is a required fields wrapper
    if ($(this).hasClass('js-required-fields-wrapper')) {
      const inputCheckedNr = $(this).find('input:checked').length
      inputCheckedNr > 0 ? $(this).removeClass('input-error') : $(this).addClass('input-error')
    }

    //check if the field is hidden
    if ($(this).is(':hidden')) $(this).removeClass('input-error')
  })
}

function submitQuoteBuilder(form, dealer, dealerName, dealerEmail, dealerManager, dealerId) {
  const builderOptions = {}
  const redirectUrl = `${theme.url}/shopping-tools-request-a-quote-success/`
  const model = getModelName(form.find('.js-product-selected input:checked').val())
  const formData = form.serializeArray()
  const summaryUrl = ''
  form.find(':submit').prop('disabled', true)

  const postData = {
    action: 'sendquote',
    formData: formData,
    builderOptions: builderOptions,
    builderModel: model,
    summaryUrl: summaryUrl,
    dealerInfo: {
      address: dealer,
      emails: dealerEmail,
      manager_emails: dealerManager,
      id: dealerId,
      name: dealerName,
    },
  }

  //first send the request to the dealer
  $.ajax({
    type: 'POST',
    dataType: 'html',
    url: theme.ajax,
    data: postData,
    beforeSend: function () {},
    success: function (data) {
      data = JSON.parse(data)

      if (
        data.email &&
        (data.email[0].status == 'sent' || data.email[0].status == 'queued' || data.email[0].status == 'scheduled')
      ) {
        //quote sent -> redirect to success page + send summary email + subscribe to newsletter if required
        emailSummary(form, false, redirectUrl)
      } else {
        form.find(':submit').prop('disabled', false)
        form
          .addClass('has-error')
          .removeClass('loading')
          .find('.error-message')
          .text('There was an error while sending the email. Please try later.')
      }
    },
    error: function (jqXHR) {
      const errorMessage =
        jqXHR && jqXHR.status === 400
          ? 'Security check failed. Please try again.'
          : 'There was an error while sending the email. Please try later.'
      form.addClass('has-error').removeClass('loading').find('.error-message').text(errorMessage)

      if (window.turnstile && typeof window.turnstile.reset === 'function') {
        window.turnstile.reset()
      }
    },
  })
}

/**
 * Send Product Quote Request/Summary Email
 */
function emailSummary(form, noDealerInfo, redirectUrl) {
  //should check if need to include dealer or not (email summary vs get quote)
  const builderOptions = {}
  const summaryUrl = ''
  const model = getModelName(form.find('.js-product-selected input:checked').val())
  const productPageUrl = form.find('.js-product-selected input:checked').attr('data-product-url')
  const brochureUrl = form.find('.js-product-selected input:checked').attr('data-brochure')
  const brochureThumbUrl = form.find('.js-product-selected input:checked').attr('data-brochure-url')
  const productPreview = form.find('.js-product-selected input:checked').attr('data-product-preview')
  const productHero = form.find('.js-product-selected input:checked').attr('data-product-hero')
  const total = ''
  const requestType = 'YOUR REQUESTED QUOTE FOR'
  const formData = form.serializeArray()
  form.find(':submit').prop('disabled', true)

  let dealerInfo
  let dealerId

  if (noDealerInfo) {
    dealerInfo = ''
    dealerId = ''
  } else {
    dealerInfo = setDealerInfo(form)
    dealerId = getDealerId(form)
  }

  if (redirectUrl == undefined) {
    redirectUrl = `${theme.url}/build/email-summary-success`
  }

  const postData = {
    action: 'sendsummary',
    requestType: requestType,
    formData: formData,
    productPreview: productPreview,
    productHero: productHero,
    brochureUrl: brochureUrl,
    brochureThumbUrl: brochureThumbUrl,
    productPageUrl: productPageUrl,
    builderOptions: builderOptions,
    builderModel: model,
    summaryUrl: summaryUrl,
    total: total,
    dealerInfo: {
      address: dealerInfo,
      id: dealerId,
    },
  }

  $.ajax({
    type: 'POST',
    dataType: 'html',
    url: theme.ajax,
    data: postData,
    beforeSend: function () {},
    success: function (data) {
      data = JSON.parse(data)

      if (
        data.lead.success === true &&
        (data.email[0].status == 'sent' || data.email[0].status == 'queued' || data.email[0].status == 'scheduled')
      ) {
        //check if user wanted to be subscribed
        if (form.find('.js-subscribe-newsletter-builder').is(':checked')) {
          subscribeMarketingNewsletter(formData, redirectUrl)
        } else {
          window.location.replace(redirectUrl)
        }
      } else {
        form
          .addClass('has-error')
          .removeClass('loading')
          .find('.error-message')
          .text('There was an error while sending the email. Please try later.')
        form.find(':submit').prop('disabled', false)
      }
    },
    error: function () {
      form
        .addClass('has-error')
        .removeClass('loading')
        .find('.error-message')
        .text('There was an error while sending the email. Please try later.')
      form.find(':submit').prop('disabled', false)
    },
  })
}

function sendBrochureRequest(form) {
  let dataForm = form.serialize()
  const url = `${theme.url}/shopping-tools-download-brochures`
  const subscribeNewsletter = form.find('.js-subscribe-newsletter-builder').is(':checked')
  form.find(':submit').prop('disabled', true)

  const dealerFollowUp = form.find('#dealer-follow-up-2').is(':checked')
  if (dealerFollowUp) {
    const dealer = form.find('.js-dealers-list').children('option:selected')
    dataForm = `${dataForm}&dealerInfo=${setDealerInfo(form)}&dealerName=${encodeURIComponent(
      dealer.val()
    )}&dealerEmail=${dealer.attr('data-email')}&dealerManager=${dealer.attr('data-manager')}&dealerId=${dealer.attr(
      'data-id'
    )}`
  }

  $.ajax({
    type: 'POST',
    dataType: 'html',
    url: theme.ajax,
    data: `${dataForm}&action=sendbrochure`,
    beforeSend: function () {},
    success: function (data) {
      data = JSON.parse(data)

      if (data[0] && (data[0].status == 'sent' || data[0].status == 'queued' || data[0].status == 'scheduled')) {
        if (subscribeNewsletter) {
          subscribeMarketingNewsletter(dataForm, url)
        }
        if (form.find('#dealer-follow-up-2').is(':checked')) {
          //dealer follow up
          sendBrochureDealer(form, dataForm)
        } else {
          window.location.replace(url)
        }
      } else {
        form
          .addClass('has-error')
          .removeClass('loading')
          .find('.error-message')
          .text('There was an error while sending the email. Please try later.')
        form.find(':submit').prop('disabled', false)
      }
    },
    error: function (jqXHR) {
      const errorMessage =
        jqXHR && jqXHR.status === 400
          ? 'Security check failed. Please try again.'
          : 'There was an error while requesting the brochure. Please try later.'
      form.addClass('has-error').removeClass('loading').find('.error-message').text(errorMessage)
      form.find(':submit').prop('disabled', false)

      if (window.turnstile && typeof window.turnstile.reset === 'function') {
        window.turnstile.reset()
      }
    },
  })
}

function sendBrochureDealer(form, dataForm) {
  const url = `${theme.url}/download-brochures-dealer-follow`
  form.find(':submit').prop('disabled', true)

  $.ajax({
    type: 'POST',
    dataType: 'html',
    url: theme.ajax,
    data: `${dataForm}&action=sendbrochuredealer`,
    beforeSend: function () {},
    success: function (data) {
      data = JSON.parse(data)

      if (data[0] && (data[0].status == 'sent' || data[0].status == 'queued' || data[0].status == 'scheduled')) {
        window.location.replace(url)
      } else {
        form
          .addClass('has-error')
          .removeClass('loading')
          .find('.error-message')
          .text('There was an error while sending the email. Please try later.')
        form.find(':submit').prop('disabled', false)
      }
    },
    error: function () {
      form
        .addClass('has-error')
        .removeClass('loading')
        .find('.error-message')
        .text('There was an error while sending the email. Please try later.')
      form.find(':submit').prop('disabled', false)
    },
  })
}

function getModelName(model) {
  const modelName = model.replace('/', ' ')

  return modelName.capitalize()
}

String.prototype.capitalize = function () {
  return this.toLowerCase().replace(/\b\w/g, function (m) {
    // capitalize letters after a word boundary
    return m.toUpperCase()
  })
}

function subscribeMarketingNewsletter(data, url) {
  $.ajax({
    type: 'POST',
    dataType: 'html',
    url: theme.ajax,
    data: `${data}&action=subscribemarketingnewsletter`,
    beforeSend: function () {},
    success: function () {},
    complete: function () {
      if (url !== undefined) {
        window.location.replace(url)
      }
    },
  })
}
